import React from 'react';

const QuestionContext = React.createContext([]);

export default QuestionContext;
